import { render, staticRenderFns } from "./HistoryItemHeading.vue?vue&type=template&id=43de0228&scoped=true"
import script from "./HistoryItemHeading.vue?vue&type=script&lang=js"
export * from "./HistoryItemHeading.vue?vue&type=script&lang=js"
import style0 from "./HistoryItemHeading.vue?vue&type=style&index=0&id=43de0228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43de0228",
  null
  
)

export default component.exports